var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"x-tab"},_vm._l((_vm.data),function(item,index){return _c('li',{key:index,class:{ active: _vm.tabActiveIndex === index },on:{"click":function($event){return _vm.tabClick(item.value,index)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }